import {
  IconDefinition,
  faUser,
  faDesktop,
  faQuestionCircle,
  faLifeRing,
} from '@fortawesome/pro-solid-svg-icons';

export interface ICard {
  color: 'orange' | 'green' | 'red' | 'blue';
  icon: IconDefinition;
  name: string;
  url: string;
}

/**
 * Is displayed on /activate route
 *
 * # Example
 * <pre>
 *   <activate></activate>
 * </pre>
 */
angular.module('gateApp').component('activate', {
  template: require('./activate.html').default,
  controller: class {
    username: string;
    message: string;
    error: string;

    cards: ICard[];

    constructor(
      private $routeParams: ng.route.IRouteParamsService,
      private $translate: ng.translate.ITranslateService,
      private user,
    ) {
      this.cards = [
        {
          color: 'orange',
          icon: faUser,
          name: $translate.instant('gate.cards.account'),
          url: '#/account',
        },
        {
          color: 'green',
          icon: faDesktop,
          name: $translate.instant('gate.cards.apps'),
          url: 'https://softwearbv.statuspage.io/',
        },
        {
          color: 'red',
          icon: faQuestionCircle,
          name: $translate.instant('gate.cards.questions'),
          url: 'https://help.softwear.nl',
        },
        {
          color: 'blue',
          icon: faLifeRing,
          name: 'Support',
          url: '#/support',
        },
      ];
    }

    $onInit() {
      this.username =
        this.$routeParams.username ||
        this.$translate.instant('gate.activate.new_user');
    }

    activate(pwd1, pwd2) {
      this.error = undefined;
      this.message = undefined;

      // TODO GATE-225 use notificationManger & update e2e
      return this.user
        .passwordReset(this.username, this.$routeParams.key, pwd1, pwd2)
        .then(() => this.$translate('gate.password_reseted'))
        .then((message) => (this.message = message))
        .catch((errorMessage) => (this.error = errorMessage));
    }
  },
});
